module.exports = __webpack_public_path__ + "assets/64fda43245d6ee5560524e4f31920bf1.mp3";